/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiCredentialsRequestResponseFromJSON, ApiRequestTokenResponseFromJSON, } from '../models';
/**
 *
 */
export class OAuthServiceApi extends runtime.BaseAPI {
    /**
     */
    oAuthServiceCredentialsRequestRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
                throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling oAuthServiceCredentialsRequest.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/oauth/v1/{clientId}/request-credentials`.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiCredentialsRequestResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    oAuthServiceCredentialsRequest(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.oAuthServiceCredentialsRequestRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    oAuthServiceRequestTokenRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
                throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling oAuthServiceRequestToken.');
            }
            const queryParameters = {};
            if (requestParameters.clientSecret !== undefined) {
                queryParameters['clientSecret'] = requestParameters.clientSecret;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/oauth/v1/{clientId}/request-token`.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiRequestTokenResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    oAuthServiceRequestToken(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.oAuthServiceRequestTokenRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
